module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAFRAQMAAACST0HKAAAAA1BMVEX///+nxBvIAAAAL0lEQVR42u3BMQEAAADCIPuntsROYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDiZAwAAYBhH+IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/place-holder.png
// module id = 1117
// module chunks = 106077160987319